export default function () {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.41667 9.47684V14.0833L5.55192 12.8292C5.6251 12.8 5.66169 12.7853 5.69946 12.7795C5.73296 12.7744 5.76704 12.7744 5.80054 12.7795C5.83831 12.7853 5.8749 12.8 5.94808 12.8292L9.08333 14.0833V9.47684M10.75 5.75C10.75 8.51142 8.51142 10.75 5.75 10.75C2.98858 10.75 0.75 8.51142 0.75 5.75C0.75 2.98858 2.98858 0.75 5.75 0.75C8.51142 0.75 10.75 2.98858 10.75 5.75Z"
        stroke="#669F2A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
